import React from 'react'

import {
  getListAPI,
  getServicesListAPI,
  deleteAPI,
  updateAPI,
} from 'services/helpers/apis/supplierNameVariant'
import Table from './table'

const SupplierNameVariants = () => {
  return (
    <Table
      getListAPI={getListAPI}
      getServicesListAPI={getServicesListAPI}
      deleteAPI={deleteAPI}
      updateAPI={updateAPI}
      tableFor='supplier'
    />
  )
}

export default SupplierNameVariants
